var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImg3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 710.935,
    height: 567.297,
    viewBox: "0 0 710.935 567.297",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 0.302,
    x2: 0.5,
    y2: 0.645,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c2eed3",
    stopOpacity: 0.031
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c2eed3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6361",
    "data-name": "Path 6361",
    d: "M298.529,293.477,296.8,271H416.1l1.873,22.477Z",
    transform: "translate(-296.8 -271)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6363",
    "data-name": "Path 6363",
    d: "M300.429,312.777,298.7,290.3H418l1.729,22.477Z",
    transform: "translate(-298.7 -290.3)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6365",
    "data-name": "Path 6365",
    d: "M324.085,331.036,322.5,310h66.134l1.585,21.036Z",
    transform: "translate(-322.5 -310)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6440",
    "data-name": "Path 6440",
    d: "M306.509,263.423,305.5,250.6h79.677l1.009,12.823Z",
    transform: "translate(-305.5 -250.6)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7372",
    "data-name": "Group 7372",
    transform: "translate(-124.133 -317.853)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Floor",
    transform: "translate(124.133 474.762)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Floor_4_",
    cx: 355.468,
    cy: 205.194,
    rx: 355.468,
    ry: 205.194,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "send_invite",
    "data-name": "send invite",
    transform: "translate(38.467 206.519)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Plant",
    transform: "translate(168.2 361.556)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6354",
    "data-name": "Group 6354"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6348",
    "data-name": "Group 6348"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6292",
    "data-name": "Group 6292",
    transform: "translate(15.306)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6291",
    "data-name": "Group 6291"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6316",
    "data-name": "Path 6316",
    d: "M199.682,495.648s0-.144.288-.576a13.329,13.329,0,0,1,.72-1.441,29.088,29.088,0,0,0,2.017-6.052c1.441-5.331,1.873-13.544-.144-23.341a128.051,128.051,0,0,0-4.322-15.561c-1.873-5.619-3.89-11.383-5.619-17.866a67.552,67.552,0,0,1-2.738-20.46c.288-7.2,2.449-14.408,4.755-21.612s4.755-14.264,5.475-21.324a32.836,32.836,0,0,0-3.89-19.739c-3.17-5.763-7.06-10.662-9.942-15.7a52.744,52.744,0,0,1-6.051-15.129,58.963,58.963,0,0,1-.432-23.485A44.947,44.947,0,0,1,182.248,285a2.272,2.272,0,0,1-.144.576,11.684,11.684,0,0,0-.432,1.585c-.432,1.441-1.009,3.458-1.585,6.2a56.169,56.169,0,0,0,.576,23.341,53.641,53.641,0,0,0,6.051,14.984c2.882,5.043,6.916,9.942,10.086,15.7a32.775,32.775,0,0,1,4.034,20.027c-.72,7.2-3.17,14.264-5.475,21.468s-4.467,14.264-4.755,21.468a67.226,67.226,0,0,0,2.738,20.316c1.729,6.34,3.746,12.247,5.619,17.722a111.446,111.446,0,0,1,4.178,15.7c2.017,9.8,1.441,18.01,0,23.485a38.461,38.461,0,0,1-2.161,6.051l-.72,1.441C199.682,495.5,199.682,495.648,199.682,495.648Z",
    transform: "translate(-178.823 -285)",
    fill: "#44494d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6296",
    "data-name": "Group 6296",
    transform: "translate(24.879 21.543)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6293",
    "data-name": "Group 6293"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6317",
    "data-name": "Path 6317",
    d: "M187.1,330.423s-5.907-19.019,4.755-30.257a.688.688,0,0,1,1.153.288C193.583,303.623,194.3,313.277,187.1,330.423Z",
    transform: "translate(-185.467 -299.952)",
    fill: "#36c96d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6295",
    "data-name": "Group 6295",
    transform: "translate(1.538 6.553)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6294",
    "data-name": "Group 6294"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6318",
    "data-name": "Path 6318",
    d: "M190.231,304.5c.144,0,0,1.3-.432,3.458-.432,2.449-.865,5.331-1.3,8.357-.432,3.17-1.009,6.051-1.3,8.357-.288,2.161-.576,3.458-.576,3.458-.144,0-.144-1.3.144-3.6.144-2.161.576-5.187,1.153-8.5s1.153-6.2,1.585-8.357A10.543,10.543,0,0,1,190.231,304.5Z",
    transform: "translate(-186.534 -304.5)",
    fill: "#44494d"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6300",
    "data-name": "Group 6300",
    transform: "translate(33.409 72.445)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6297",
    "data-name": "Group 6297",
    transform: "translate(0.162)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6319",
    "data-name": "Path 6319",
    d: "M191.5,359.8s3.6-19.6,18.3-24.494a.68.68,0,0,1,.865.865C209.654,339.2,205.764,347.988,191.5,359.8Z",
    transform: "translate(-191.5 -335.281)",
    fill: "#36c96d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6299",
    "data-name": "Group 6299",
    transform: "translate(0 5.071)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6298",
    "data-name": "Group 6298"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6320",
    "data-name": "Path 6320",
    d: "M205.814,338.8a16.9,16.9,0,0,1-2.017,2.882c-1.441,2.017-3.17,4.322-5.187,6.772-1.873,2.593-3.6,4.9-5.043,6.772a21.642,21.642,0,0,1-2.161,2.738,11.961,11.961,0,0,1,1.729-3.026,82.126,82.126,0,0,1,4.9-6.916c2.017-2.593,3.89-5.043,5.331-6.628A23.643,23.643,0,0,1,205.814,338.8Z",
    transform: "translate(-191.387 -338.8)",
    fill: "#44494d"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6304",
    "data-name": "Group 6304",
    transform: "translate(29.395 117.314)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6301",
    "data-name": "Group 6301"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6321",
    "data-name": "Path 6321",
    d: "M188.743,395.351s-2.161-19.883,10.374-28.816a.647.647,0,0,1,1.009.576C200.126,370.281,199.117,379.79,188.743,395.351Z",
    transform: "translate(-188.601 -366.422)",
    fill: "#36c96d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6303",
    "data-name": "Group 6303",
    transform: "translate(0.105 6.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6302",
    "data-name": "Group 6302"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6322",
    "data-name": "Path 6322",
    d: "M196.78,370.7c.144,0-.288,1.3-1.009,3.314-.865,2.305-1.873,5.043-2.882,8.069-1.153,3.026-2.017,5.763-2.882,8.069a17.215,17.215,0,0,1-1.3,3.314c-.144,0,.144-1.3.72-3.458s1.585-4.9,2.738-8.069,2.305-5.907,3.17-7.925C196.059,371.853,196.636,370.7,196.78,370.7Z",
    transform: "translate(-188.675 -370.7)",
    fill: "#44494d"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6308",
    "data-name": "Group 6308",
    transform: "translate(40.459 167.31)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6305",
    "data-name": "Group 6305",
    transform: "translate(0.123)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6323",
    "data-name": "Path 6323",
    d: "M196.415,429.619s-1.441-19.883,11.382-28.384a.647.647,0,0,1,1.009.576C208.662,404.981,207.221,414.49,196.415,429.619Z",
    transform: "translate(-196.366 -401.122)",
    fill: "#36c96d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6307",
    "data-name": "Group 6307",
    transform: "translate(0 6.02)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6306",
    "data-name": "Group 6306"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6324",
    "data-name": "Path 6324",
    d: "M205.242,405.3a20.881,20.881,0,0,1-1.153,3.314c-.864,2.305-2.017,4.9-3.17,7.924-1.153,2.882-2.305,5.619-3.17,7.924a24.387,24.387,0,0,1-1.441,3.314,18.75,18.75,0,0,1,.864-3.458c.72-2.017,1.729-4.9,3.026-7.924s2.449-5.907,3.458-7.78A22.9,22.9,0,0,1,205.242,405.3Z",
    transform: "translate(-196.281 -405.3)",
    fill: "#44494d"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6312",
    "data-name": "Group 6312",
    transform: "translate(0 9.829)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6309",
    "data-name": "Group 6309"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6325",
    "data-name": "Path 6325",
    d: "M186.21,317.149s-17.722-9.221-18.01-24.638a.647.647,0,0,1,1.009-.576C171.8,293.808,179.006,300,186.21,317.149Z",
    transform: "translate(-168.2 -291.822)",
    fill: "#36c96d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6311",
    "data-name": "Group 6311",
    transform: "translate(3.584 6.02)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6310",
    "data-name": "Group 6310"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6326",
    "data-name": "Path 6326",
    d: "M170.706,296a19.553,19.553,0,0,1,2.161,2.738c1.441,2.017,3.17,4.322,5.043,6.916s3.6,4.9,5.043,6.916a16.9,16.9,0,0,1,2.017,2.882,13.885,13.885,0,0,1-2.449-2.593c-1.441-1.729-3.314-4.034-5.187-6.772-2.017-2.738-3.6-5.187-4.755-7.06C171.282,297.153,170.561,296,170.706,296Z",
    transform: "translate(-170.687 -296)",
    fill: "#44494d"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6316",
    "data-name": "Group 6316",
    transform: "translate(17.434 51.901)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6313",
    "data-name": "Group 6313"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6327",
    "data-name": "Path 6327",
    d: "M199.9,345.34s-18.3-8.213-19.6-23.629a.647.647,0,0,1,1.009-.576C184.046,322.719,191.682,328.627,199.9,345.34Z",
    transform: "translate(-180.3 -321.022)",
    fill: "#36c96d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6315",
    "data-name": "Group 6315",
    transform: "translate(4.016 5.732)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6314",
    "data-name": "Group 6314"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6328",
    "data-name": "Path 6328",
    d: "M183.106,325a17.29,17.29,0,0,1,2.305,2.593c1.585,1.873,3.314,4.178,5.331,6.628s3.89,4.611,5.475,6.628a17.6,17.6,0,0,1,2.161,2.738s-1.009-.865-2.593-2.449c-1.441-1.585-3.458-3.89-5.619-6.484s-3.89-5.043-5.187-6.772C183.682,326.3,182.961,325.144,183.106,325Z",
    transform: "translate(-183.087 -325)",
    fill: "#44494d"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6320",
    "data-name": "Group 6320",
    transform: "translate(18.301 91.663)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6317",
    "data-name": "Group 6317"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6329",
    "data-name": "Path 6329",
    d: "M189.112,378.849s-12.535-15.561-6.628-29.825a.678.678,0,0,1,1.153-.144C185.222,351.617,189.4,360.262,189.112,378.849Z",
    transform: "translate(-180.902 -348.619)",
    fill: "#36c96d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6319",
    "data-name": "Group 6319",
    transform: "translate(2.698 6.601)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6318",
    "data-name": "Group 6318"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6330",
    "data-name": "Path 6330",
    d: "M182.811,353.2c.144,0,.432,1.3.865,3.458.576,2.449,1.153,5.187,1.873,8.357s1.3,5.907,1.873,8.357c.432,2.161.72,3.458.72,3.458a13.11,13.11,0,0,1-1.153-3.314c-.576-2.161-1.3-5.043-2.017-8.357s-1.3-6.2-1.585-8.357C182.956,354.641,182.667,353.344,182.811,353.2Z",
    transform: "translate(-182.774 -353.2)",
    fill: "#44494d"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6324",
    "data-name": "Group 6324",
    transform: "translate(19.739 151.029)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6321",
    "data-name": "Group 6321"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6331",
    "data-name": "Path 6331",
    d: "M201.063,414.429s-18.154-8.5-19.163-23.918a.647.647,0,0,1,1.009-.576C185.646,391.664,193.138,397.571,201.063,414.429Z",
    transform: "translate(-181.9 -389.822)",
    fill: "#36c96d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6323",
    "data-name": "Group 6323",
    transform: "translate(3.89 5.876)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6322",
    "data-name": "Group 6322"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6332",
    "data-name": "Path 6332",
    d: "M184.6,393.9a15.019,15.019,0,0,1,2.305,2.738c1.585,1.873,3.314,4.178,5.331,6.628s3.746,4.755,5.331,6.628a17.272,17.272,0,0,1,2.161,2.882s-1.009-.864-2.593-2.449c-1.441-1.585-3.458-3.89-5.475-6.484s-3.89-5.043-5.187-6.772C185.32,395.053,184.6,393.9,184.6,393.9Z",
    transform: "translate(-184.6 -393.9)",
    fill: "#44494d"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6347",
    "data-name": "Group 6347",
    transform: "translate(34.439 92.581)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6326",
    "data-name": "Group 6326",
    transform: "translate(5.904 4.531)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6325",
    "data-name": "Group 6325"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6333",
    "data-name": "Path 6333",
    d: "M230.78,352.4v1.729c0,1.153-.144,2.882-.144,4.9-.288,4.322-.576,10.23-1.009,17.29h0c-1.3,7.2-5.043,15.273-9.942,23.053-3.6,5.763-7.492,10.95-10.662,15.849a136.964,136.964,0,0,0-8.069,13.256,51.9,51.9,0,0,0-3.746,9.8c-.288,1.153-.576,2.161-.72,2.738s-.288,1.009-.288,1.009a6.027,6.027,0,0,1,.144-1.009c.144-.576.288-1.585.576-2.738a45,45,0,0,1,3.6-9.942,100.6,100.6,0,0,1,7.925-13.4c3.314-4.9,7.06-10.086,10.662-15.849,4.9-7.78,8.645-15.7,9.942-22.765h0c.432-7.06.864-12.967,1.153-17.29.144-2.017.288-3.6.432-4.9,0-.576.144-.865.144-1.3Z",
    transform: "translate(-196.2 -352.4)",
    fill: "#44494d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6331",
    "data-name": "Group 6331",
    transform: "translate(25.729 19.12)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6327",
    "data-name": "Group 6327"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6334",
    "data-name": "Path 6334",
    d: "M213.908,393.322s7.636-18.442-2.017-30.545a.654.654,0,0,0-1.153.288C210.018,366.091,208.433,375.6,213.908,393.322Z",
    transform: "translate(-209.959 -362.526)",
    fill: "#36c96d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6329",
    "data-name": "Group 6329",
    transform: "translate(2.557 6.735)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6328",
    "data-name": "Group 6328"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6335",
    "data-name": "Path 6335",
    d: "M211.829,367.2c.144,0,.288,1.3.576,3.458s.576,5.187.865,8.5.288,6.34.288,8.5-.144,3.6-.144,3.6a17.564,17.564,0,0,1-.288-3.458c-.144-2.449-.288-5.331-.576-8.5s-.432-6.051-.576-8.5C211.685,368.5,211.685,367.2,211.829,367.2Z",
    transform: "translate(-211.734 -367.2)",
    fill: "#44494d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6330",
    "data-name": "Group 6330",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6336",
    "data-name": "Path 6336",
    d: "M213.908,393.322s7.636-18.442-2.017-30.545a.654.654,0,0,0-1.153.288C210.018,366.091,208.433,375.6,213.908,393.322Z",
    transform: "translate(-209.959 -362.526)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6336",
    "data-name": "Group 6336",
    transform: "translate(0 63.929)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6332",
    "data-name": "Group 6332"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6337",
    "data-name": "Path 6337",
    d: "M198.006,424.134s6.2-19.019-4.467-30.257a.645.645,0,0,0-1.153.288C191.955,397.191,191.09,406.844,198.006,424.134Z",
    transform: "translate(-192.102 -393.626)",
    fill: "#36c96d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6334",
    "data-name": "Group 6334",
    transform: "translate(2.59 6.591)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6333",
    "data-name": "Group 6333"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6338",
    "data-name": "Path 6338",
    d: "M193.9,398.2c.144,0,.432,1.3.864,3.458s1.009,5.043,1.441,8.357a82.375,82.375,0,0,1,1.009,8.5c.144,2.161.144,3.6.144,3.6-.144,0-.288-1.3-.576-3.458-.432-2.449-.72-5.331-1.3-8.357-.432-3.17-.864-6.052-1.3-8.357C194.044,399.5,193.9,398.2,193.9,398.2Z",
    transform: "translate(-193.9 -398.2)",
    fill: "#44494d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6335",
    "data-name": "Group 6335",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6339",
    "data-name": "Path 6339",
    d: "M198.006,424.134s6.2-19.019-4.467-30.257a.645.645,0,0,0-1.153.288C191.955,397.191,191.09,406.844,198.006,424.134Z",
    transform: "translate(-192.102 -393.626)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6341",
    "data-name": "Group 6341",
    transform: "translate(39.475)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6337",
    "data-name": "Group 6337"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6340",
    "data-name": "Path 6340",
    d: "M219.5,376.7s16.425-11.527,14.7-26.8a.666.666,0,0,0-1.153-.432C230.738,351.481,224.255,358.685,219.5,376.7Z",
    transform: "translate(-219.5 -349.256)",
    fill: "#36c96d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6338",
    "data-name": "Group 6338",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6341",
    "data-name": "Path 6341",
    d: "M219.5,376.7s16.425-11.527,14.7-26.8a.666.666,0,0,0-1.153-.432C230.738,351.481,224.255,358.685,219.5,376.7Z",
    transform: "translate(-219.5 -349.256)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6340",
    "data-name": "Group 6340",
    transform: "translate(0.27 6.26)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6339",
    "data-name": "Group 6339"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6342",
    "data-name": "Path 6342",
    d: "M231.232,353.6a16.1,16.1,0,0,1-1.3,3.314c-.865,2.017-2.305,4.611-3.89,7.636-1.585,2.882-3.17,5.475-4.322,7.348a24.848,24.848,0,0,1-2.017,2.882,17.055,17.055,0,0,1,1.585-3.17c1.153-2.161,2.593-4.611,4.034-7.492,1.585-2.738,2.882-5.331,4.034-7.492A13.762,13.762,0,0,1,231.232,353.6Z",
    transform: "translate(-219.687 -353.6)",
    fill: "#44494d"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6346",
    "data-name": "Group 6346",
    transform: "translate(12.532 57.093)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6342",
    "data-name": "Group 6342"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6343",
    "data-name": "Path 6343",
    d: "M200.8,407.351s19.739-3.026,25.07-17.578a.68.68,0,0,0-.865-.865C221.98,389.773,213.047,393.375,200.8,407.351Z",
    transform: "translate(-200.8 -388.881)",
    fill: "#36c96d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6343",
    "data-name": "Group 6343",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6344",
    "data-name": "Path 6344",
    d: "M200.8,407.351s19.739-3.026,25.07-17.578a.68.68,0,0,0-.865-.865C221.98,389.773,213.047,393.375,200.8,407.351Z",
    transform: "translate(-200.8 -388.881)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6345",
    "data-name": "Group 6345",
    transform: "translate(0.288 4.639)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6344",
    "data-name": "Group 6344"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6345",
    "data-name": "Path 6345",
    d: "M220.6,392.1A17.288,17.288,0,0,1,218,394.405c-1.729,1.3-4.178,3.17-6.772,5.187-2.738,1.873-5.187,3.6-7.06,4.755a19.3,19.3,0,0,1-3.17,1.729,17.043,17.043,0,0,1,2.882-2.161c2.017-1.441,4.322-3.026,6.916-4.9s4.9-3.458,6.916-4.9C219.443,392.82,220.6,392.1,220.6,392.1Z",
    transform: "translate(-201 -392.1)",
    fill: "#44494d"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6349",
    "data-name": "Group 6349",
    transform: "translate(22.477 204.452)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6346",
    "data-name": "Path 6346",
    d: "M189.563,426.9,183.8,465.658h35.876L214.922,426.9Z",
    transform: "translate(-183.8 -426.9)",
    fill: "#3d3d3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6351",
    "data-name": "Group 6351",
    transform: "translate(26.223 215.979)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6350",
    "data-name": "Group 6350"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6347",
    "data-name": "Path 6347",
    d: "M215.216,435.332c0,.144-6.484.432-14.408.432s-14.408-.144-14.408-.432c0-.144,6.484-.432,14.408-.432C208.733,435.044,215.216,435.188,215.216,435.332Z",
    transform: "translate(-186.4 -434.9)",
    fill: "#44494d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6353",
    "data-name": "Group 6353",
    transform: "translate(25.791 219.149)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6352",
    "data-name": "Group 6352"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6348",
    "data-name": "Path 6348",
    d: "M216.069,437.532c0,.144-6.628.432-14.985.432-8.213,0-14.985-.144-14.985-.432,0-.144,6.628-.432,14.985-.432S216.069,437.244,216.069,437.532Z",
    transform: "translate(-186.1 -437.1)",
    fill: "#44494d"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Paper_Plane",
    transform: "translate(304.236 111.334)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6352",
    "data-name": "Path 6352",
    d: "M315,303.207s61.091-18.731,42.648-62.676-35.588,20.6-8.069,24.35S414.7,229,382.142,176.127c0,0-32.563-44.81-67.142-46.827",
    transform: "translate(-239.524 -103.414)",
    fill: "none",
    stroke: "#36c96d",
    strokeLinecap: "round",
    strokeWidth: 1,
    strokeDasharray: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6353",
    "data-name": "Path 6353",
    d: "M313,303.207s61.091-18.731,42.648-62.676-35.588,20.6-8.069,24.35S412.7,229,380.142,176.127c0,0-32.563-44.81-67.142-46.827",
    transform: "translate(-240.405 -103.414)",
    fill: "none",
    stroke: "#36c96d",
    strokeLinecap: "round",
    strokeWidth: 1,
    strokeDasharray: 4,
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6287_1_",
    transform: "translate(0 10.086)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8_",
    d: "M349.6,217.6l77.948,20.316L440.8,266.444Z",
    transform: "translate(-349.6 -207.658)",
    fill: "#36c96d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7_",
    d: "M349.6,220.642l75.787,9.8,2.161-19.739Z",
    transform: "translate(-349.6 -210.7)",
    fill: "#36c96d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6_",
    d: "M425.387,227.4l-8.357,7.636L349.6,217.6Z",
    transform: "translate(-349.6 -207.658)",
    fill: "#36c96d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5_",
    d: "M425.387,227.4l-8.357,7.636L349.6,217.6Z",
    transform: "translate(-349.6 -207.658)",
    opacity: 0.25
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6287"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1116_",
    d: "M349.6,210.6l77.948,20.316L440.8,259.444Z",
    transform: "translate(-349.6 -200.658)",
    fill: "#36c96d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1115_",
    d: "M349.6,213.642l75.787,9.8,2.161-19.739Z",
    transform: "translate(-349.6 -203.7)",
    fill: "#36c96d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1114_",
    d: "M425.387,220.4l-8.357,7.636L349.6,210.6Z",
    transform: "translate(-349.6 -200.658)",
    fill: "#36c96d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1113_",
    d: "M425.387,220.4l-8.357,7.636L349.6,210.6Z",
    transform: "translate(-349.6 -200.658)",
    opacity: 0.25
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Character_1",
    transform: "translate(316.172 278.145)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6723",
    "data-name": "Group 6723",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6406",
    "data-name": "Group 6406",
    transform: "translate(0 11.514)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6384",
    "data-name": "Group 6384"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6370",
    "data-name": "Group 6370"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6365",
    "data-name": "Group 6365"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6360",
    "data-name": "Group 6360",
    transform: "translate(71.609 136.734)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6359",
    "data-name": "Group 6359"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6358",
    "data-name": "Group 6358"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6357",
    "data-name": "Group 6357"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6359",
    "data-name": "Rectangle 6359",
    width: 209.063,
    height: 10.23,
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6364",
    "data-name": "Group 6364"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6363",
    "data-name": "Group 6363"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6362",
    "data-name": "Group 6362"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6361",
    "data-name": "Group 6361"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6354",
    "data-name": "Path 6354",
    d: "M310.234,382.064,270.9,235.1H434.145l35.588,146.964Z",
    transform: "translate(-270.9 -235.1)",
    fill: "#263238"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6369",
    "data-name": "Group 6369",
    transform: "translate(9.221 6.772)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6368",
    "data-name": "Group 6368"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6367",
    "data-name": "Group 6367"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6366",
    "data-name": "Group 6366"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6355",
    "data-name": "Path 6355",
    d: "M457.114,368.753H311.3L277.3,239.8H423.831Z",
    transform: "translate(-277.3 -239.8)",
    fill: "#f5f5f5"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6373",
    "data-name": "Group 6373",
    transform: "translate(9.221 6.772)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6372",
    "data-name": "Group 6372"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6371",
    "data-name": "Group 6371"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6356",
    "data-name": "Path 6356",
    d: "M279.749,249.021H426.281l-2.449-9.221H277.3Z",
    transform: "translate(-277.3 -239.8)",
    fill: "#ebebeb"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6383",
    "data-name": "Group 6383",
    transform: "translate(16.569 9.798)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6376",
    "data-name": "Group 6376",
    transform: "translate(10.95)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6375",
    "data-name": "Group 6375"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6374",
    "data-name": "Group 6374"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6357",
    "data-name": "Path 6357",
    d: "M290,243.485a1.585,1.585,0,1,0,1.585-1.585A1.6,1.6,0,0,0,290,243.485Z",
    transform: "translate(-290 -241.9)",
    fill: "#fafafa"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6379",
    "data-name": "Group 6379",
    transform: "translate(5.475)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6378",
    "data-name": "Group 6378"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6377",
    "data-name": "Group 6377"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6358",
    "data-name": "Path 6358",
    d: "M286.2,243.485a1.585,1.585,0,1,0,1.585-1.585A1.6,1.6,0,0,0,286.2,243.485Z",
    transform: "translate(-286.2 -241.9)",
    fill: "#fafafa"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6382",
    "data-name": "Group 6382"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6381",
    "data-name": "Group 6381"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6380",
    "data-name": "Group 6380"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6359",
    "data-name": "Path 6359",
    d: "M282.4,243.485a1.585,1.585,0,1,0,1.585-1.585A1.512,1.512,0,0,0,282.4,243.485Z",
    transform: "translate(-282.4 -241.9)",
    fill: "#fafafa"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6391",
    "data-name": "Group 6391",
    transform: "translate(37.317 51.725)",
    opacity: 0.08
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6390",
    "data-name": "Group 6390"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6389",
    "data-name": "Group 6389"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6388",
    "data-name": "Group 6388",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6387",
    "data-name": "Group 6387",
    transform: "translate(0.132)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6386",
    "data-name": "Group 6386"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6385",
    "data-name": "Group 6385"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6360",
    "data-name": "Path 6360",
    d: "M301.082,292.036a1.532,1.532,0,0,1-1.441-1.3l-1.3-17a1.177,1.177,0,0,1,1.153-1.3H413.61a1.532,1.532,0,0,1,1.441,1.3l1.3,17a1.177,1.177,0,0,1-1.153,1.3H301.082M413.466,271H299.353a2.5,2.5,0,0,0-2.449,2.738l1.3,17a3.081,3.081,0,0,0,2.882,2.738H415.2a2.5,2.5,0,0,0,2.449-2.738l-1.3-17A2.96,2.96,0,0,0,413.466,271",
    transform: "translate(-296.892 -271)",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6398",
    "data-name": "Group 6398",
    transform: "translate(40.055 79.533)",
    opacity: 0.08
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6397",
    "data-name": "Group 6397"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6396",
    "data-name": "Group 6396"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6395",
    "data-name": "Group 6395",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6394",
    "data-name": "Group 6394",
    transform: "translate(0.132)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6393",
    "data-name": "Group 6393"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6392",
    "data-name": "Group 6392"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6362",
    "data-name": "Path 6362",
    d: "M302.982,311.336a1.532,1.532,0,0,1-1.441-1.3l-1.3-17a1.177,1.177,0,0,1,1.153-1.3H415.51a1.532,1.532,0,0,1,1.441,1.3l1.3,17a1.177,1.177,0,0,1-1.153,1.3H302.982M415.366,290.3H301.253a2.5,2.5,0,0,0-2.449,2.738l1.3,17a2.96,2.96,0,0,0,2.882,2.738H417.1a2.5,2.5,0,0,0,2.449-2.738l-1.3-17a3.081,3.081,0,0,0-2.882-2.738",
    transform: "translate(-298.792 -290.3)",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6405",
    "data-name": "Group 6405",
    transform: "translate(74.346 107.917)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6404",
    "data-name": "Group 6404"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6403",
    "data-name": "Group 6403"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6402",
    "data-name": "Group 6402",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6401",
    "data-name": "Group 6401",
    transform: "translate(0.122)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6400",
    "data-name": "Group 6400"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6399",
    "data-name": "Group 6399"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6364",
    "data-name": "Path 6364",
    d: "M387.156,310H323.9a1.3,1.3,0,0,0-1.3,1.585l1.441,18.01a1.6,1.6,0,0,0,1.585,1.585h63.252a1.3,1.3,0,0,0,1.3-1.585l-1.441-18.01A1.829,1.829,0,0,0,387.156,310",
    transform: "translate(-322.585 -310)",
    fill: "#263238"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6408",
    "data-name": "Group 6408",
    transform: "translate(4.178 157.325)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6407",
    "data-name": "Group 6407"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6366",
    "data-name": "Path 6366",
    d: "M273.8,336.3v7.924h5.187V504.444H289.5V344.225h56.48V504.444h10.662V344.225h244.8V504.444H612.1V344.225h4.611V336.3Z",
    transform: "translate(-273.8 -336.3)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6412",
    "data-name": "Group 6412",
    transform: "translate(234.71 216.686)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6411",
    "data-name": "Group 6411"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6410",
    "data-name": "Group 6410"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6409",
    "data-name": "Group 6409"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6367",
    "data-name": "Path 6367",
    d: "M433.8,377.788a83.122,83.122,0,0,0,13.832,0,83.14,83.14,0,0,0-13.832,0Z",
    transform: "translate(-433.8 -377.5)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6415",
    "data-name": "Group 6415",
    transform: "translate(133.564 218.271)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6414",
    "data-name": "Group 6414"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6413",
    "data-name": "Group 6413"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2961",
    "data-name": "Ellipse 2961",
    cx: 0.432,
    cy: 0.144,
    rx: 0.432,
    ry: 0.144,
    fill: "#455a64"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6714",
    "data-name": "Group 6714",
    transform: "translate(109.336)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6439",
    "data-name": "Group 6439",
    transform: "translate(20.661 59.459)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6417",
    "data-name": "Group 6417"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6416",
    "data-name": "Group 6416"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6368",
    "data-name": "Path 6368",
    d: "M438.029,306.16l-52.014-22.333-2.449-3.746c-.432-.72-1.009-1.441-1.441-2.305a13.216,13.216,0,0,1-1.3-3.314,16.214,16.214,0,0,1-.432-4.322c.144-1.3-1.3-2.305-2.161-1.441s-1.441,4.467-.144,8.789c1.3,4.178-4.322.288-6.484-1.153-2.017-1.441-8.645-5.475-9.654-5.187-1.3.432-1.153,2.017,1.009,3.314,2.161,1.441,8.213,5.907,7.348,6.916h0a5.063,5.063,0,0,0-4.034,4.611c-.144,2.161-.144,5.043,1.153,5.907a59.506,59.506,0,0,0,8.357,3.746l1.729.576s50.717,33.139,58.209,31.7c4.755-.865,73.626-22.477,73.626-22.477L506.9,284.98Z",
    transform: "translate(-361.125 -268.376)",
    fill: "#ffbe9d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6423",
    "data-name": "Group 6423",
    transform: "translate(5.295 19.313)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6419",
    "data-name": "Group 6419",
    transform: "translate(0.288 0.172)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6418",
    "data-name": "Group 6418"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6369",
    "data-name": "Path 6369",
    d: "M365,285.358c1.585.576,3.17,1.3,4.755,1.873a7.6,7.6,0,0,0,1.729.432,1.585,1.585,0,0,0,1.441-.865,1.775,1.775,0,0,0-.288-1.441c-.288-.432-.864-.576-1.3-.865-1.585-.864-3.314-1.729-4.9-2.593",
    transform: "translate(-365 -281.9)",
    fill: "#ffbe9d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6422",
    "data-name": "Group 6422"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6421",
    "data-name": "Group 6421"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6420",
    "data-name": "Group 6420"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6370",
    "data-name": "Path 6370",
    d: "M366.241,281.808c0-.144,1.009.288,2.305,1.009A18.755,18.755,0,0,0,371,283.97a7.633,7.633,0,0,1,1.441.865,2.212,2.212,0,0,1,.72,1.873,1.678,1.678,0,0,1-1.729,1.153,3.074,3.074,0,0,1-1.729-.432c-.864-.432-1.729-.72-2.593-1.153a13.739,13.739,0,0,1-2.305-1.153c0-.144,1.009.144,2.449.72l2.593.865a5.119,5.119,0,0,0,1.441.288,1.084,1.084,0,0,0,1.009-.72,1.2,1.2,0,0,0-.432-1.153,10.118,10.118,0,0,0-1.3-.865c-.865-.432-1.585-.865-2.449-1.3A5.086,5.086,0,0,1,366.241,281.808Z",
    transform: "translate(-364.8 -281.781)",
    fill: "#e8945b"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6429",
    "data-name": "Group 6429",
    transform: "translate(6.736 16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6425",
    "data-name": "Group 6425",
    transform: "translate(0.288 0.028)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6424",
    "data-name": "Group 6424"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6371",
    "data-name": "Path 6371",
    d: "M366,282.958c1.585.576,3.17,1.3,4.755,1.873a7.6,7.6,0,0,0,1.729.432,1.585,1.585,0,0,0,1.441-.865,1.774,1.774,0,0,0-.288-1.441c-.288-.432-.865-.576-1.3-.864-1.585-.865-3.314-1.729-4.9-2.594",
    transform: "translate(-366 -279.5)",
    fill: "#ffbe9d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6428",
    "data-name": "Group 6428"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6427",
    "data-name": "Group 6427"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6426",
    "data-name": "Group 6426"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6372",
    "data-name": "Path 6372",
    d: "M367.241,279.508c0-.144,1.009.288,2.305,1.009A18.757,18.757,0,0,0,372,281.67a7.631,7.631,0,0,1,1.441.865,2.213,2.213,0,0,1,.72,1.873,1.678,1.678,0,0,1-1.729,1.153,3.073,3.073,0,0,1-1.729-.432c-.864-.432-1.729-.72-2.593-1.153a13.74,13.74,0,0,1-2.305-1.153c0-.144,1.009.144,2.449.72l2.593.865a5.119,5.119,0,0,0,1.441.288,1.084,1.084,0,0,0,1.009-.72,1.2,1.2,0,0,0-.432-1.153,10.124,10.124,0,0,0-1.3-.865c-.865-.432-1.585-.865-2.449-1.3C368.105,280.085,367.241,279.508,367.241,279.508Z",
    transform: "translate(-365.8 -279.481)",
    fill: "#e8945b"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6435",
    "data-name": "Group 6435",
    transform: "translate(8.609 12.974)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6431",
    "data-name": "Group 6431",
    transform: "translate(0.288 0.028)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6430",
    "data-name": "Group 6430"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6373",
    "data-name": "Path 6373",
    d: "M367.3,280.858c1.585.576,3.17,1.3,4.755,1.873a7.6,7.6,0,0,0,1.729.432,1.585,1.585,0,0,0,1.441-.864,1.774,1.774,0,0,0-.288-1.441c-.288-.432-.864-.576-1.3-.864-1.585-.865-3.314-1.729-4.9-2.593",
    transform: "translate(-367.3 -277.4)",
    fill: "#ffbe9d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6434",
    "data-name": "Group 6434"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6433",
    "data-name": "Group 6433"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6432",
    "data-name": "Group 6432"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6374",
    "data-name": "Path 6374",
    d: "M368.541,277.408c0-.144,1.009.288,2.305,1.009a18.749,18.749,0,0,0,2.449,1.153,7.633,7.633,0,0,1,1.441.865,2.212,2.212,0,0,1,.72,1.873,1.678,1.678,0,0,1-1.729,1.153,3.073,3.073,0,0,1-1.729-.432c-.865-.432-1.729-.72-2.593-1.153a13.737,13.737,0,0,1-2.305-1.153c0-.144,1.009.144,2.449.72l2.593.865a5.118,5.118,0,0,0,1.441.288,1.084,1.084,0,0,0,1.009-.72,1.2,1.2,0,0,0-.432-1.153,10.11,10.11,0,0,0-1.3-.865c-.865-.432-1.585-.865-2.449-1.3C369.405,277.985,368.541,277.408,368.541,277.408Z",
    transform: "translate(-367.1 -277.381)",
    fill: "#e8945b"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6438",
    "data-name": "Group 6438",
    transform: "translate(16.534 12.83)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6437",
    "data-name": "Group 6437"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6436",
    "data-name": "Group 6436"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6375",
    "data-name": "Path 6375",
    d: "M372.6,284.368c0-.144.72-.576,2.161-.72l-.288.432a5.623,5.623,0,0,1-1.009-2.305,6.125,6.125,0,0,1,.144-3.314c.288-.865.576-1.3.72-1.153a11.333,11.333,0,0,0-.144,4.467,7.511,7.511,0,0,0,.865,2.161l.288.432h-.576C373.465,284.224,372.744,284.512,372.6,284.368Z",
    transform: "translate(-372.6 -277.281)",
    fill: "#e8945b"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6451",
    "data-name": "Group 6451",
    transform: "translate(102.262)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6444",
    "data-name": "Group 6444"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6441",
    "data-name": "Group 6441",
    transform: "translate(6.193 8.776)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6440",
    "data-name": "Group 6440"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6376",
    "data-name": "Path 6376",
    d: "M458,239.972l.144,55.328-21.612,1.009-.865-13.256s-10.374,1.585-12.535-6.2c-1.441-5.043-1.009-43.657-1.009-43.657Z",
    transform: "translate(-422.058 -233.2)",
    fill: "#ffbe9d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6443",
    "data-name": "Group 6443"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6442",
    "data-name": "Group 6442"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6377",
    "data-name": "Path 6377",
    d: "M418.682,241.216c1.585,3.314,9.221,9.365,9.221,9.365l3.458,9.221c3.026-2.305,7.06-2.161,7.78,3.026.576,3.746-4.178,4.611-4.178,4.611,2.738,4.611,4.611,8.5,8.645,12.823,4.323,4.755,6.772,5.331,11.382,5.331h5.187s10.518-8.789,8.5-32.13c-2.161-23.341-23.053-16.425-27.952-22.333C432.514,221.765,413.351,230.266,418.682,241.216Z",
    transform: "translate(-417.76 -227.109)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6447",
    "data-name": "Group 6447",
    transform: "translate(1.174 9.064)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6446",
    "data-name": "Group 6446"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6445",
    "data-name": "Group 6445"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6378",
    "data-name": "Path 6378",
    d: "M467.167,270.285a8.817,8.817,0,0,1-2.594-.144,13.251,13.251,0,0,1-6.2-3.17c-2.305-1.873-4.323-4.9-6.2-8.213-2.017-3.314-4.178-7.06-7.925-9.653-3.746-2.449-8.213-3.026-11.959-3.746-3.89-.72-7.348-1.873-9.654-3.6a11.632,11.632,0,0,1-3.89-5.763,8.915,8.915,0,0,1-.144-2.593,7.135,7.135,0,0,0,.288,2.593,11.352,11.352,0,0,0,3.89,5.619c2.305,1.873,5.763,2.882,9.509,3.6s8.213,1.3,12.1,3.746c3.746,2.593,6.051,6.484,7.925,9.8,2.017,3.314,3.89,6.34,6.2,8.213a12.3,12.3,0,0,0,6.051,3.17,17.715,17.715,0,0,1,1.873.288A2.522,2.522,0,0,1,467.167,270.285Z",
    transform: "translate(-418.575 -233.4)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6450",
    "data-name": "Group 6450",
    transform: "translate(1.355 5.894)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6449",
    "data-name": "Group 6449"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6448",
    "data-name": "Group 6448"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6379",
    "data-name": "Path 6379",
    d: "M468.264,252.236a10.58,10.58,0,0,0-1.153-.288,24.469,24.469,0,0,0-3.314-.72,7.611,7.611,0,0,0-5.043,1.153,3.7,3.7,0,0,0-1.729,2.594,3.593,3.593,0,0,0,1.009,3.314,2.658,2.658,0,0,0,1.729.72,2.9,2.9,0,0,0,1.873-.576,6.024,6.024,0,0,0,2.594-3.314,8.256,8.256,0,0,0-2.305-8.789,7.9,7.9,0,0,0-4.611-2.017,13.643,13.643,0,0,0-5.331.72,33.706,33.706,0,0,1-5.475,1.3,20.284,20.284,0,0,1-5.907,0,18.066,18.066,0,0,1-5.619-1.585,7.13,7.13,0,0,1-3.89-4.034,5.235,5.235,0,0,1,1.3-5.187,4.627,4.627,0,0,1,5.043-.72,4.378,4.378,0,0,1,1.873,1.729,4.658,4.658,0,0,1,.432,2.449,5.079,5.079,0,0,1-2.593,3.89,7.809,7.809,0,0,1-4.323,1.153,18.164,18.164,0,0,1-4.034-.576,14.172,14.172,0,0,1-5.907-3.6,14.839,14.839,0,0,1-3.026-4.322,15.233,15.233,0,0,1-1.009-3.17,6.527,6.527,0,0,1-.144-1.153,10.579,10.579,0,0,1,.288,1.153,10.775,10.775,0,0,0,1.153,3.17,14.84,14.84,0,0,0,3.026,4.322,14.172,14.172,0,0,0,5.907,3.6,12.431,12.431,0,0,0,4.034.576,7.346,7.346,0,0,0,4.178-1.153,5.624,5.624,0,0,0,2.449-3.746,3.5,3.5,0,0,0-2.161-3.89,4.2,4.2,0,0,0-4.755.72,5.046,5.046,0,0,0-1.3,4.9,6.255,6.255,0,0,0,3.746,3.89,18.066,18.066,0,0,0,5.619,1.585,19.309,19.309,0,0,0,5.763,0c1.873-.288,3.746-.864,5.475-1.3a17.334,17.334,0,0,1,5.475-.72,8.076,8.076,0,0,1,4.755,2.161,8.452,8.452,0,0,1,2.305,9.077,5.975,5.975,0,0,1-2.738,3.458,4.69,4.69,0,0,1-2.017.576,2.739,2.739,0,0,1-1.873-.72,3.51,3.51,0,0,1-1.009-3.458,4.158,4.158,0,0,1,1.873-2.738,7.781,7.781,0,0,1,5.043-1.153,24.479,24.479,0,0,1,3.314.72A1.96,1.96,0,0,1,468.264,252.236Z",
    transform: "translate(-418.7 -231.2)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6558",
    "data-name": "Group 6558",
    transform: "translate(117.328 289.592)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6554",
    "data-name": "Group 6554"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6553",
    "data-name": "Group 6553"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6457",
    "data-name": "Group 6457",
    transform: "translate(0.034)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6456",
    "data-name": "Group 6456"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6455",
    "data-name": "Group 6455"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6454",
    "data-name": "Group 6454"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6453",
    "data-name": "Group 6453"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6452",
    "data-name": "Group 6452"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6380",
    "data-name": "Path 6380",
    d: "M436.683,450.433l-7.06-9.077L446.481,428.1,457,441.212l-1.009.864c-4.467,3.89-22.909,19.6-26.8,21.18C424.868,464.985,436.683,450.433,436.683,450.433Z",
    transform: "translate(-428.24 -428.1)",
    fill: "#263238"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6462",
    "data-name": "Group 6462",
    transform: "translate(0 12.823)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6461",
    "data-name": "Group 6461"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6460",
    "data-name": "Group 6460"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6459",
    "data-name": "Group 6459"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6458",
    "data-name": "Group 6458"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6381",
    "data-name": "Path 6381",
    d: "M431.074,453.858s-3.89,5.475-2.593,5.763,20.46-14.84,28.384-22.333l-.288-.288-22.333,17.866C434.388,454.866,432.083,453.137,431.074,453.858Z",
    transform: "translate(-428.216 -437)",
    fill: "#fff"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6468",
    "data-name": "Group 6468",
    transform: "translate(0.12 12.535)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6467",
    "data-name": "Group 6467"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6466",
    "data-name": "Group 6466"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6465",
    "data-name": "Group 6465"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6464",
    "data-name": "Group 6464"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6463",
    "data-name": "Group 6463"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6382",
    "data-name": "Path 6382",
    d: "M456.828,436.8l-.288.288c-.288.144-.432.432-.72.72-.864.72-1.729,1.585-3.026,2.593-2.449,2.161-6.051,5.043-9.942,8.213s-7.636,5.907-10.23,7.78c-1.3.864-2.305,1.729-3.17,2.305a3.012,3.012,0,0,1-.865.576.446.446,0,0,1-.288.144l.288-.288c.288-.144.576-.432.865-.576.864-.576,1.873-1.441,3.17-2.305,2.593-2.017,6.2-4.755,10.23-7.925,3.89-3.17,7.492-6.051,9.942-8.069a32.4,32.4,0,0,1,3.026-2.449c.288-.288.576-.432.865-.72A.5.5,0,0,1,456.828,436.8Z",
    transform: "translate(-428.3 -436.8)",
    fill: "#44494d"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6474",
    "data-name": "Group 6474",
    transform: "translate(2.57 29.587)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6473",
    "data-name": "Group 6473"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6472",
    "data-name": "Group 6472"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6471",
    "data-name": "Group 6471"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6470",
    "data-name": "Group 6470"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6469",
    "data-name": "Group 6469"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6383",
    "data-name": "Path 6383",
    d: "M433.746,450.026a8.294,8.294,0,0,0-1.729-1.009,4.186,4.186,0,0,0-2.017-.288,3.323,3.323,0,0,1,2.017.144A3.118,3.118,0,0,1,433.746,450.026Z",
    transform: "translate(-430 -448.635)",
    fill: "#263238"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6480",
    "data-name": "Group 6480",
    transform: "translate(7.325 23.774)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6479",
    "data-name": "Group 6479"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6478",
    "data-name": "Group 6478"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6477",
    "data-name": "Group 6477"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6476",
    "data-name": "Group 6476"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6475",
    "data-name": "Group 6475"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6384",
    "data-name": "Path 6384",
    d: "M435.317,445.32a2.489,2.489,0,0,1-1.009-.288,3.587,3.587,0,0,1-1.009-.432,2.489,2.489,0,0,1,1.009.288A3.586,3.586,0,0,1,435.317,445.32Z",
    transform: "translate(-433.3 -444.6)",
    fill: "#263238"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6486",
    "data-name": "Group 6486",
    transform: "translate(8.333 22.621)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6485",
    "data-name": "Group 6485"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6484",
    "data-name": "Group 6484"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6483",
    "data-name": "Group 6483"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6482",
    "data-name": "Group 6482"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6481",
    "data-name": "Group 6481"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6385",
    "data-name": "Path 6385",
    d: "M435.729,443.944a2.665,2.665,0,0,1-1.729,0,3.14,3.14,0,0,1,.864-.144C435.3,443.8,435.729,443.8,435.729,443.944Z",
    transform: "translate(-434 -443.8)",
    fill: "#263238"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6492",
    "data-name": "Group 6492",
    transform: "translate(7.901 20.46)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6491",
    "data-name": "Group 6491"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6490",
    "data-name": "Group 6490"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6489",
    "data-name": "Group 6489"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6488",
    "data-name": "Group 6488"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6487",
    "data-name": "Group 6487"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6386",
    "data-name": "Path 6386",
    d: "M435.429,442.3a6.394,6.394,0,0,1-.72.864c-.432.432-.865.72-1.009.576a6.389,6.389,0,0,1,.72-.864A3.986,3.986,0,0,1,435.429,442.3Z",
    transform: "translate(-433.7 -442.3)",
    fill: "#263238"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6498",
    "data-name": "Group 6498",
    transform: "translate(7.181 19.019)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6497",
    "data-name": "Group 6497"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6496",
    "data-name": "Group 6496"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6495",
    "data-name": "Group 6495"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6494",
    "data-name": "Group 6494"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6493",
    "data-name": "Group 6493"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6387",
    "data-name": "Path 6387",
    d: "M435.073,441.3a4.443,4.443,0,0,1-.72,1.009,8.51,8.51,0,0,1-1.153.72,10.506,10.506,0,0,1,1.009-.865Z",
    transform: "translate(-433.2 -441.3)",
    fill: "#44494d"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6504",
    "data-name": "Group 6504",
    transform: "translate(3.519 23.239)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6503",
    "data-name": "Group 6503"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6502",
    "data-name": "Group 6502"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6501",
    "data-name": "Group 6501"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6500",
    "data-name": "Group 6500"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6499",
    "data-name": "Group 6499"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6388",
    "data-name": "Path 6388",
    d: "M434.753,444.475a3.075,3.075,0,0,1-1.153.864c-.432.288-.864.432-1.3.72-.288.144-.576.144-.864.288a.866.866,0,0,1-.576-.144c-.144-.144-.288-.432-.144-.576a2.469,2.469,0,0,1,2.882-1.3,2.347,2.347,0,0,1,.865.432l.288.288a2.427,2.427,0,0,0-1.153-.576,2.6,2.6,0,0,0-1.441.144,1.831,1.831,0,0,0-1.153,1.153.382.382,0,0,0,.432.432,2.048,2.048,0,0,0,.865-.288,5.648,5.648,0,0,0,1.3-.576C434.32,444.763,434.608,444.475,434.753,444.475Z",
    transform: "translate(-430.659 -444.229)",
    fill: "#44494d"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6510",
    "data-name": "Group 6510",
    transform: "translate(6.316 20.691)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6509",
    "data-name": "Group 6509"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6508",
    "data-name": "Group 6508"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6507",
    "data-name": "Group 6507"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6506",
    "data-name": "Group 6506"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6505",
    "data-name": "Group 6505"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6389",
    "data-name": "Path 6389",
    d: "M433.609,445.543a1.411,1.411,0,0,1-.72-.72,2.083,2.083,0,0,1-.288-1.009,1.588,1.588,0,0,1,.432-1.3.526.526,0,0,1,.72.288.866.866,0,0,1,.144.576v1.009c0,.72-.144,1.009-.288,1.153a5.11,5.11,0,0,0,.144-1.009v-1.009c0-.288-.288-.865-.576-.72s-.288.72-.288,1.009a2.082,2.082,0,0,0,.288,1.009A2.031,2.031,0,0,0,433.609,445.543Z",
    transform: "translate(-432.6 -442.461)",
    fill: "#44494d"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6516",
    "data-name": "Group 6516",
    transform: "translate(21.007 8.213)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6515",
    "data-name": "Group 6515"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6514",
    "data-name": "Group 6514"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6513",
    "data-name": "Group 6513"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6512",
    "data-name": "Group 6512"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6511",
    "data-name": "Group 6511"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6390",
    "data-name": "Path 6390",
    d: "M446.4,433.8a3.9,3.9,0,0,0-1.153,1.009,8.021,8.021,0,0,0-1.873,3.314,7.853,7.853,0,0,0,.144,3.746c.288.864.72,1.441.576,1.441l-.288-.288a8.281,8.281,0,0,0-.576-1.009,6.615,6.615,0,0,1-.288-3.89,5.468,5.468,0,0,1,2.017-3.314c.432-.288.72-.576,1.009-.72C446.26,433.8,446.4,433.8,446.4,433.8Z",
    transform: "translate(-442.796 -433.8)",
    fill: "#44494d"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6522",
    "data-name": "Group 6522",
    transform: "translate(17.399 2.593)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6521",
    "data-name": "Group 6521"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6520",
    "data-name": "Group 6520"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6519",
    "data-name": "Group 6519"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6518",
    "data-name": "Group 6518"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6517",
    "data-name": "Group 6517"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6391",
    "data-name": "Path 6391",
    d: "M440.3,429.9s1.3,1.441,2.882,3.314,2.737,3.458,2.737,3.458-1.3-1.441-2.882-3.314A27.381,27.381,0,0,1,440.3,429.9Z",
    transform: "translate(-440.292 -429.9)",
    fill: "#44494d"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6528",
    "data-name": "Group 6528",
    transform: "translate(14.241 17.866)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6527",
    "data-name": "Group 6527"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6526",
    "data-name": "Group 6526"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6525",
    "data-name": "Group 6525"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6524",
    "data-name": "Group 6524"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6523",
    "data-name": "Group 6523"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6392",
    "data-name": "Path 6392",
    d: "M443,440.5a11.122,11.122,0,0,1-2.305,2.161,7.418,7.418,0,0,1-2.593,1.729s1.153-.864,2.449-2.017A27.074,27.074,0,0,1,443,440.5Z",
    transform: "translate(-438.1 -440.5)",
    fill: "#263238"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6534",
    "data-name": "Group 6534",
    transform: "translate(22.165 15.273)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6533",
    "data-name": "Group 6533"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6532",
    "data-name": "Group 6532"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6531",
    "data-name": "Group 6531"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6530",
    "data-name": "Group 6530"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6529",
    "data-name": "Group 6529"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6393",
    "data-name": "Path 6393",
    d: "M443.744,438.7c.144,0,.144.288.144.576a1.567,1.567,0,0,1,.144.72,1,1,0,0,1-.432-.576A1.747,1.747,0,0,1,443.744,438.7Z",
    transform: "translate(-443.6 -438.7)",
    fill: "#44494d"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6540",
    "data-name": "Group 6540",
    transform: "translate(22.245 12.679)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6539",
    "data-name": "Group 6539"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6538",
    "data-name": "Group 6538"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6537",
    "data-name": "Group 6537"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6536",
    "data-name": "Group 6536"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6535",
    "data-name": "Group 6535"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6394",
    "data-name": "Path 6394",
    d: "M443.864,436.9a.7.7,0,0,1,0,.576,1.49,1.49,0,0,1-.144.576.7.7,0,0,1,0-.576C443.576,437.188,443.72,436.9,443.864,436.9Z",
    transform: "translate(-443.656 -436.9)",
    fill: "#44494d"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6546",
    "data-name": "Group 6546",
    transform: "translate(22.849 10.608)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6545",
    "data-name": "Group 6545"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6544",
    "data-name": "Group 6544"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6543",
    "data-name": "Group 6543"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6542",
    "data-name": "Group 6542"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6541",
    "data-name": "Group 6541"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6395",
    "data-name": "Path 6395",
    d: "M444.831,435.517a2.487,2.487,0,0,1-.432.576l-.288.576a.75.75,0,0,1,.144-.72C444.543,435.517,444.831,435.372,444.831,435.517Z",
    transform: "translate(-444.075 -435.462)",
    fill: "#44494d"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6552",
    "data-name": "Group 6552",
    transform: "translate(24.326 9.221)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6551",
    "data-name": "Group 6551"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6550",
    "data-name": "Group 6550"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6549",
    "data-name": "Group 6549"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6548",
    "data-name": "Group 6548"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6547",
    "data-name": "Group 6547"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6396",
    "data-name": "Path 6396",
    d: "M445.388,434.5v.432l-.288.288v-.432Z",
    transform: "translate(-445.1 -434.5)",
    fill: "#44494d"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6557",
    "data-name": "Group 6557",
    transform: "translate(5.596 6.628)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6556",
    "data-name": "Group 6556"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6555",
    "data-name": "Group 6555"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6397",
    "data-name": "Path 6397",
    d: "M450.831,433.853,433.685,446.82,432.1,444.8l18.01-12.1Z",
    transform: "translate(-432.1 -432.7)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6665",
    "data-name": "Group 6665",
    transform: "translate(33.68 309.331)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6661",
    "data-name": "Group 6661"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6660",
    "data-name": "Group 6660"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6564",
    "data-name": "Group 6564",
    transform: "translate(0.112)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6563",
    "data-name": "Group 6563"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6562",
    "data-name": "Group 6562"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6561",
    "data-name": "Group 6561"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6560",
    "data-name": "Group 6560"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6559",
    "data-name": "Group 6559"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6398",
    "data-name": "Path 6398",
    d: "M384.735,453.471V441.944L406.2,441.8l.144,16.714-1.3.144c-5.907.288-30.113,1.3-34.147.144C366.581,457.649,384.735,453.471,384.735,453.471Z",
    transform: "translate(-370.238 -441.8)",
    fill: "#263238"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6569",
    "data-name": "Group 6569",
    transform: "translate(0 14.12)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6568",
    "data-name": "Group 6568"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6567",
    "data-name": "Group 6567"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6566",
    "data-name": "Group 6566"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6565",
    "data-name": "Group 6565"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6399",
    "data-name": "Path 6399",
    d: "M375.837,451.6s-6.34,1.873-5.619,2.882c.865,1.009,25.358,1.009,36.165,0v-.432l-28.528.432C377.854,454.338,377.133,451.6,375.837,451.6Z",
    transform: "translate(-370.16 -451.6)",
    fill: "#cbcbcb"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6575",
    "data-name": "Group 6575",
    transform: "translate(0.201 16.425)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6574",
    "data-name": "Group 6574"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6573",
    "data-name": "Group 6573"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6572",
    "data-name": "Group 6572"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6571",
    "data-name": "Group 6571"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6570",
    "data-name": "Group 6570"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6400",
    "data-name": "Path 6400",
    d: "M406.609,453.2h-1.441c-1.009,0-2.305.144-3.89.144-3.314.144-7.78.288-12.823.288s-9.654,0-12.823-.144c-1.585,0-2.882-.144-3.89-.144h3.89c3.314,0,7.78.144,12.823.144s9.509-.144,12.823-.144c1.585,0,2.882-.144,3.89-.144h1.441Z",
    transform: "translate(-370.3 -453.2)",
    fill: "#44494d"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6581",
    "data-name": "Group 6581",
    transform: "translate(5.66 13.832)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6580",
    "data-name": "Group 6580"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6579",
    "data-name": "Group 6579"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6578",
    "data-name": "Group 6578"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6577",
    "data-name": "Group 6577"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6576",
    "data-name": "Group 6576"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6401",
    "data-name": "Path 6401",
    d: "M376.122,454.714c-.144,0-.144-.864-.72-1.873a6.994,6.994,0,0,0-1.3-1.441,2.939,2.939,0,0,1,1.585,1.3A5.738,5.738,0,0,1,376.122,454.714Z",
    transform: "translate(-374.089 -451.4)",
    fill: "#44494d"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6587",
    "data-name": "Group 6587",
    transform: "translate(12.842 12.103)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6586",
    "data-name": "Group 6586"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6585",
    "data-name": "Group 6585"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6584",
    "data-name": "Group 6584"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6583",
    "data-name": "Group 6583"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6582",
    "data-name": "Group 6582"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6402",
    "data-name": "Path 6402",
    d: "M380.264,452.073a2.4,2.4,0,0,1-.72-.864c-.288-.432-.576-.865-.432-1.009a2.4,2.4,0,0,1,.72.865A2.507,2.507,0,0,1,380.264,452.073Z",
    transform: "translate(-379.073 -450.2)",
    fill: "#44494d"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6593",
    "data-name": "Group 6593",
    transform: "translate(14.465 11.815)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6592",
    "data-name": "Group 6592"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6591",
    "data-name": "Group 6591"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6590",
    "data-name": "Group 6590"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6589",
    "data-name": "Group 6589"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6588",
    "data-name": "Group 6588"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6403",
    "data-name": "Path 6403",
    d: "M381.5,451.153a2.108,2.108,0,0,1-.72-.432c-.432-.288-.576-.576-.576-.72a2.108,2.108,0,0,1,.72.432A5.2,5.2,0,0,0,381.5,451.153Z",
    transform: "translate(-380.2 -450)",
    fill: "#44494d"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6599",
    "data-name": "Group 6599",
    transform: "translate(14.465 10.806)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6598",
    "data-name": "Group 6598"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6597",
    "data-name": "Group 6597"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6596",
    "data-name": "Group 6596"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6595",
    "data-name": "Group 6595"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6594",
    "data-name": "Group 6594"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6404",
    "data-name": "Path 6404",
    d: "M382.505,449.444c0,.144-.432.144-1.153.144-.576,0-1.153,0-1.153-.144a4.682,4.682,0,0,1,2.305,0Z",
    transform: "translate(-380.2 -449.3)",
    fill: "#44494d"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6605",
    "data-name": "Group 6605",
    transform: "translate(14.609 9.509)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6604",
    "data-name": "Group 6604"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6603",
    "data-name": "Group 6603"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6602",
    "data-name": "Group 6602"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6601",
    "data-name": "Group 6601"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6600",
    "data-name": "Group 6600"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6405",
    "data-name": "Path 6405",
    d: "M382.893,448.4a5.766,5.766,0,0,1-1.3.432,5.943,5.943,0,0,1-1.3-.144c0-.144.576,0,1.3-.144A7.356,7.356,0,0,1,382.893,448.4Z",
    transform: "translate(-380.3 -448.4)",
    fill: "#44494d"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6611",
    "data-name": "Group 6611",
    transform: "translate(9.134 10.22)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6610",
    "data-name": "Group 6610"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6609",
    "data-name": "Group 6609"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6608",
    "data-name": "Group 6608"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6607",
    "data-name": "Group 6607"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6606",
    "data-name": "Group 6606"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6406",
    "data-name": "Path 6406",
    d: "M380.534,450.776a3.87,3.87,0,0,1-1.441,0,6.34,6.34,0,0,1-1.441-.288c-.288-.144-.576-.144-.864-.288-.144-.144-.288-.288-.288-.432a.866.866,0,0,1,.144-.576,2.531,2.531,0,0,1,3.17.72,1.585,1.585,0,0,1,.432.865v.432a3.6,3.6,0,0,0-.576-1.153,3.139,3.139,0,0,0-1.153-.72,2.041,2.041,0,0,0-1.585.144c-.288.144-.144.432.144.576a2.434,2.434,0,0,0,.72.288c.576.144,1.009.288,1.441.432Q380.534,450.56,380.534,450.776Z",
    transform: "translate(-376.5 -448.893)",
    fill: "#44494d"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6617",
    "data-name": "Group 6617",
    transform: "translate(12.696 9.365)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6616",
    "data-name": "Group 6616"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6615",
    "data-name": "Group 6615"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6614",
    "data-name": "Group 6614"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6613",
    "data-name": "Group 6613"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6612",
    "data-name": "Group 6612"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6407",
    "data-name": "Path 6407",
    d: "M379.156,451.038a1.123,1.123,0,0,1-.144-1.009,1.557,1.557,0,0,1,.432-1.009c.288-.288.576-.72,1.153-.72.288,0,.432.432.432.576a.749.749,0,0,1-.288.576c-.144.288-.432.576-.576.864-.576.576-.864.72-1.009.72.144,0,.432-.288.72-.72.144-.288.432-.432.576-.865.144-.288.288-.864,0-.864a1.185,1.185,0,0,0-.865.576l-.432.865A1.961,1.961,0,0,0,379.156,451.038Z",
    transform: "translate(-378.972 -448.3)",
    fill: "#44494d"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6623",
    "data-name": "Group 6623",
    transform: "translate(28.441 10.374)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6622",
    "data-name": "Group 6622"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6621",
    "data-name": "Group 6621"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6620",
    "data-name": "Group 6620"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6619",
    "data-name": "Group 6619"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6618",
    "data-name": "Group 6618"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6408",
    "data-name": "Path 6408",
    d: "M397.536,449.144h-1.585a7.738,7.738,0,0,0-3.458,1.441,6.619,6.619,0,0,0-2.161,3.026c-.288.864-.288,1.585-.432,1.585v-.432a4.453,4.453,0,0,1,.288-1.153,6.287,6.287,0,0,1,2.161-3.17,6.788,6.788,0,0,1,3.6-1.441H397.1A1.115,1.115,0,0,0,397.536,449.144Z",
    transform: "translate(-389.9 -449)",
    fill: "#44494d"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6629",
    "data-name": "Group 6629",
    transform: "translate(33.772 1.585)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6628",
    "data-name": "Group 6628"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6627",
    "data-name": "Group 6627"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6626",
    "data-name": "Group 6626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6625",
    "data-name": "Group 6625"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6624",
    "data-name": "Group 6624"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6409",
    "data-name": "Path 6409",
    d: "M393.6,442.9s.144,2.017.144,4.467v4.467s-.144-2.017-.144-4.467Z",
    transform: "translate(-393.6 -442.9)",
    fill: "#44494d"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6635",
    "data-name": "Group 6635",
    transform: "translate(19.364 14.632)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6634",
    "data-name": "Group 6634"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6633",
    "data-name": "Group 6633"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6632",
    "data-name": "Group 6632"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6631",
    "data-name": "Group 6631"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6630",
    "data-name": "Group 6630"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6410",
    "data-name": "Path 6410",
    d: "M389.94,452.02a18.06,18.06,0,0,1-3.17.288,9.507,9.507,0,0,1-3.17-.288,19.39,19.39,0,0,1,3.17,0Z",
    transform: "translate(-383.6 -451.956)",
    fill: "#44494d"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6641",
    "data-name": "Group 6641",
    transform: "translate(29.386 14.696)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6640",
    "data-name": "Group 6640"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6639",
    "data-name": "Group 6639"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6638",
    "data-name": "Group 6638"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6637",
    "data-name": "Group 6637"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6636",
    "data-name": "Group 6636"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6411",
    "data-name": "Path 6411",
    d: "M391.2,452l-.288.576-.288.576a1,1,0,0,1,0-.72A.772.772,0,0,1,391.2,452Z",
    transform: "translate(-390.556 -452)",
    fill: "#44494d"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6647",
    "data-name": "Group 6647",
    transform: "translate(30.891 12.679)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6646",
    "data-name": "Group 6646"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6645",
    "data-name": "Group 6645"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6644",
    "data-name": "Group 6644"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6643",
    "data-name": "Group 6643"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6642",
    "data-name": "Group 6642"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6412",
    "data-name": "Path 6412",
    d: "M392.32,450.6a2.072,2.072,0,0,1-.288.432c-.288.288-.432.432-.432.288a2.075,2.075,0,0,1,.288-.432C392.032,450.744,392.176,450.6,392.32,450.6Z",
    transform: "translate(-391.6 -450.6)",
    fill: "#44494d"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6653",
    "data-name": "Group 6653",
    transform: "translate(32.62 11.648)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6652",
    "data-name": "Group 6652"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6651",
    "data-name": "Group 6651"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6650",
    "data-name": "Group 6650"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6649",
    "data-name": "Group 6649"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6648",
    "data-name": "Group 6648"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6413",
    "data-name": "Path 6413",
    d: "M393.953,450.051c0,.144-.288,0-.576.144l-.576.288a1,1,0,0,1,.576-.432C393.664,449.763,393.953,449.907,393.953,450.051Z",
    transform: "translate(-392.8 -449.885)",
    fill: "#44494d"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6659",
    "data-name": "Group 6659",
    transform: "translate(34.781 11.274)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6658",
    "data-name": "Group 6658"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6657",
    "data-name": "Group 6657"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6656",
    "data-name": "Group 6656"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6655",
    "data-name": "Group 6655"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6654",
    "data-name": "Group 6654"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6414",
    "data-name": "Path 6414",
    d: "M395.02,449.733l-.288.288c-.144,0-.288.144-.432,0l.288-.288A.27.27,0,0,1,395.02,449.733Z",
    transform: "translate(-394.3 -449.625)",
    fill: "#44494d"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6664",
    "data-name": "Group 6664",
    transform: "translate(14.609 7.06)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6663",
    "data-name": "Group 6663"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6662",
    "data-name": "Group 6662"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6415",
    "data-name": "Path 6415",
    d: "M401.912,449.293H380.3v-2.449l21.612-.144Z",
    transform: "translate(-380.3 -446.7)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6681",
    "data-name": "Group 6681",
    transform: "translate(0 113.812)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6668",
    "data-name": "Group 6668",
    transform: "translate(29.127)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6667",
    "data-name": "Group 6667"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6666",
    "data-name": "Group 6666"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6416",
    "data-name": "Path 6416",
    d: "M439.185,315.465,430.54,341.4c-2.305,7.06-8.5,8.213-15.849,8.213H367V338.951l43.657-6.2L421.031,306.1Z",
    transform: "translate(-367 -306.1)",
    fill: "#ffbe9d"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6680",
    "data-name": "Group 6680",
    transform: "translate(0 21.172)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6671",
    "data-name": "Group 6671"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6670",
    "data-name": "Group 6670"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6669",
    "data-name": "Group 6669"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6417",
    "data-name": "Path 6417",
    d: "M370.58,330.168l-3.746-1.729s-4.034-7.925-5.043-7.636-1.153,2.593.432,6.34l-5.043-1.441s-10.95,5.043-10.374,5.763c.432.72,1.441,2.305,3.746,1.009,2.449-1.153,5.475-2.593,5.475-2.593l5.907,1.729-7.636,1.009-7.2,6.484a3.434,3.434,0,0,0,4.322-.144L370,342.991l5.763.288V332.617Z",
    transform: "translate(-346.785 -320.795)",
    fill: "#ffbe9d"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6675",
    "data-name": "Group 6675",
    transform: "translate(4.741 14.074)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6674",
    "data-name": "Group 6674"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6673",
    "data-name": "Group 6673"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6672",
    "data-name": "Group 6672"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6418",
    "data-name": "Path 6418",
    d: "M350.111,334.507c.144,0,.432-.432,1.153-1.3a5.065,5.065,0,0,1,1.3-1.009,8.258,8.258,0,0,1,2.017-.576c3.026-.432,5.619-.72,5.619-1.009a25.869,25.869,0,0,0-5.619.432,9.481,9.481,0,0,0-2.161.576,12.991,12.991,0,0,0-1.441,1.3C350.255,333.786,349.967,334.507,350.111,334.507Z",
    transform: "translate(-350.075 -330.563)",
    fill: "#e8945b"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6679",
    "data-name": "Group 6679",
    transform: "translate(7.622 17.402)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6678",
    "data-name": "Group 6678"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6677",
    "data-name": "Group 6677"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6676",
    "data-name": "Group 6676"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6419",
    "data-name": "Path 6419",
    d: "M352.111,334.209a.719.719,0,0,1,.72-.432c.576-.144,1.441-.144,2.305-.288a20.945,20.945,0,0,0,3.314-.288,6.913,6.913,0,0,0-3.314-.288c-.865.144-1.729.288-2.305.432-.288.144-.576.432-.576.576C351.967,334.065,352.111,334.209,352.111,334.209Z",
    transform: "translate(-352.075 -332.873)",
    fill: "#e8945b"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6702",
    "data-name": "Group 6702",
    transform: "translate(78.259 65.098)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6693",
    "data-name": "Group 6693"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6688",
    "data-name": "Group 6688"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6687",
    "data-name": "Group 6687"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6686",
    "data-name": "Group 6686"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6685",
    "data-name": "Group 6685"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6684",
    "data-name": "Group 6684"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6683",
    "data-name": "Group 6683"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6682",
    "data-name": "Group 6682"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6420",
    "data-name": "Path 6420",
    d: "M428.187,324.75l-3.746,12.391L401.1,326.623c.865-2.593,4.755-14.264,12.1-32.707a31.612,31.612,0,0,1,24.206-19.451c7.636-1.3,15.993-2.305,22.333-2.161,13.112.144,32.418,8.357,35.012,21.18,2.017,9.8,0,27.087,0,48.123l-1.729,40.2-67,2.305Z",
    transform: "translate(-401.1 -272.29)",
    fill: "#36c96d"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6692",
    "data-name": "Group 6692",
    transform: "translate(43.945 59.14)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6691",
    "data-name": "Group 6691"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6690",
    "data-name": "Group 6690"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6689",
    "data-name": "Group 6689"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6421",
    "data-name": "Path 6421",
    d: "M481.308,314.148c-8.213,1.729-16.569,0-24.926-.576-5.043-.288-10.662-.865-14.552,2.305-3.17,2.449-4.467,6.628-5.331,10.518-3.458,14.84-4.178,24.782-4.9,40.055l40.343,2.449Z",
    transform: "translate(-431.6 -313.337)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6697",
    "data-name": "Group 6697",
    transform: "translate(25.358 8.947)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6696",
    "data-name": "Group 6696"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6695",
    "data-name": "Group 6695"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6694",
    "data-name": "Group 6694"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6422",
    "data-name": "Path 6422",
    d: "M418.7,278.5a9.717,9.717,0,0,1,1.729.576,9.181,9.181,0,0,1,3.89,3.17,12.762,12.762,0,0,1,2.305,6.916,52.746,52.746,0,0,1-.72,9.221,143.571,143.571,0,0,1-3.746,16.425c-.576,2.017-1.009,3.746-1.3,4.9s-.432,1.873-.432,1.873a9.285,9.285,0,0,0,.576-1.729c.432-1.153.865-2.882,1.585-4.9a116.077,116.077,0,0,0,3.89-16.425,54.347,54.347,0,0,0,.72-9.365,13.409,13.409,0,0,0-2.449-7.2,8.246,8.246,0,0,0-4.178-3.026,6.34,6.34,0,0,0-1.441-.288A1.116,1.116,0,0,0,418.7,278.5Z",
    transform: "translate(-418.7 -278.5)",
    fill: "#38932a"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6701",
    "data-name": "Group 6701",
    transform: "translate(0.865 51.163)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6700",
    "data-name": "Group 6700"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6699",
    "data-name": "Group 6699"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6698",
    "data-name": "Group 6698"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6423",
    "data-name": "Path 6423",
    d: "M401.7,307.8a20.384,20.384,0,0,0,3.314,1.873c2.017,1.153,5.043,2.449,8.213,4.034,3.314,1.441,6.2,2.738,8.5,3.458,2.161.864,3.6,1.3,3.6,1.153a15.792,15.792,0,0,0-3.458-1.585c-2.161-.865-5.043-2.161-8.357-3.746-3.314-1.441-6.2-2.882-8.213-3.89A36.822,36.822,0,0,1,401.7,307.8Z",
    transform: "translate(-401.7 -307.8)",
    fill: "#38932a"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6713",
    "data-name": "Group 6713",
    transform: "translate(36.329 174.903)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6705",
    "data-name": "Group 6705",
    transform: "translate(19.55 4.899)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6704",
    "data-name": "Group 6704"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6703",
    "data-name": "Group 6703"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6424",
    "data-name": "Path 6424",
    d: "M398.005,351.9a24.01,24.01,0,0,0-9.8,31.986l58.353,100.281L473.5,467.886,428.119,377.4l32.851-21.468",
    transform: "translate(-385.567 -351.9)",
    fill: "#242d31"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6712",
    "data-name": "Group 6712"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6708",
    "data-name": "Group 6708"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6707",
    "data-name": "Group 6707"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6706",
    "data-name": "Group 6706"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6425",
    "data-name": "Path 6425",
    d: "M475.163,348.5l-80.11,2.882A23.934,23.934,0,0,0,372,375.587l3.314,114.4,33.715-.144-1.153-108.206,67.286-1.729Z",
    transform: "translate(-371.999 -348.5)",
    fill: "#37474f"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6711",
    "data-name": "Group 6711",
    transform: "translate(35.814 37.173)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6710",
    "data-name": "Group 6710"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6709",
    "data-name": "Group 6709"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6426",
    "data-name": "Path 6426",
    d: "M396.92,374.3a4.606,4.606,0,0,0,.144,1.009c0,.72.144,1.729.144,3.026.144,2.593.144,6.484.288,11.238.144,9.365.288,22.477.432,36.885s.144,27.376.144,36.885v15.273a4.607,4.607,0,0,0-.144-1.009c0-.72-.144-1.729-.144-3.026-.144-2.593-.144-6.484-.288-11.238-.144-9.365-.288-22.477-.432-36.885s-.144-27.376-.144-36.885V375.309A1.726,1.726,0,0,1,396.92,374.3Z",
    transform: "translate(-396.856 -374.3)",
    fill: "#455a64"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6722",
    "data-name": "Group 6722",
    transform: "translate(180.967 102.285)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6716",
    "data-name": "Group 6716"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6715",
    "data-name": "Group 6715"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6427",
    "data-name": "Path 6427",
    d: "M499.086,298.1H474.881a17.709,17.709,0,0,0-17.722,17.722v84.432H408.747A12.237,12.237,0,0,0,396.5,412.5H507.155a10.13,10.13,0,0,0,9.654-10.086V315.822A17.9,17.9,0,0,0,499.086,298.1Z",
    transform: "translate(-396.5 -298.1)",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6719",
    "data-name": "Group 6719",
    transform: "translate(67.286 2.738)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6718",
    "data-name": "Group 6718"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6717",
    "data-name": "Group 6717"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6428",
    "data-name": "Path 6428",
    d: "M443.632,300c.144,0,.432,24.926.432,55.472,0,30.689-.144,55.472-.432,55.472-.144,0-.432-24.782-.432-55.472C443.2,324.926,443.344,300,443.632,300Z",
    transform: "translate(-443.2 -300)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6721",
    "data-name": "Group 6721",
    transform: "translate(26.655 114.401)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6720",
    "data-name": "Group 6720"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6429",
    "data-name": "Path 6429",
    d: "M452.894,466.255V377.5h-7.925v88.755c-4.755,9.509-16.137,15.849-29.969,21.18h70.312C471.192,481.671,458.225,477.2,452.894,466.255Z",
    transform: "translate(-415 -377.5)",
    fill: "#455a64"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6730",
    "data-name": "Group 6730",
    transform: "translate(49.852 33.846)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6729",
    "data-name": "Group 6729"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6728",
    "data-name": "Group 6728"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6727",
    "data-name": "Group 6727",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6726",
    "data-name": "Group 6726",
    transform: "translate(0.576)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6725",
    "data-name": "Group 6725"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6724",
    "data-name": "Group 6724"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6430",
    "data-name": "Path 6430",
    d: "M309.79,251a4.572,4.572,0,0,0-2.882.864,2.968,2.968,0,0,0-1.009,2.449,3.812,3.812,0,0,0,1.729,2.738,6.9,6.9,0,0,0,2.305,1.009,6.884,6.884,0,0,1,2.017.864,1.31,1.31,0,0,1,.576,1.153,1.636,1.636,0,0,1-.432,1.153,2.318,2.318,0,0,1-1.585.432,2.445,2.445,0,0,1-1.873-.576,2.064,2.064,0,0,1-.72-1.585h-1.873a3.443,3.443,0,0,0,.72,2.017,3.933,3.933,0,0,0,1.729,1.3,5.972,5.972,0,0,0,2.305.432,4.054,4.054,0,0,0,2.882-.865,2.389,2.389,0,0,0,.864-2.305,2.167,2.167,0,0,0-.576-1.585,3.4,3.4,0,0,0-1.3-1.153,12.048,12.048,0,0,0-2.305-1.009,9.285,9.285,0,0,1-2.017-.865,1.98,1.98,0,0,1-.72-1.153,2.012,2.012,0,0,1,.432-1.3,2.151,2.151,0,0,1,1.441-.432,2.244,2.244,0,0,1,2.449,2.017h2.017a3.035,3.035,0,0,0-.72-1.873,3.522,3.522,0,0,0-1.585-1.3A2.972,2.972,0,0,0,309.79,251",
    transform: "translate(-305.9 -250.424)",
    fill: "#242424"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6431",
    "data-name": "Path 6431",
    d: "M314.69,256.846a2.589,2.589,0,0,1,.432-1.585,1.747,1.747,0,0,1,2.593,0,2.3,2.3,0,0,1,.576,1.585v.144h-3.6m1.729-3.89a3.308,3.308,0,0,0-2.017.576,3.523,3.523,0,0,0-1.3,1.585,4.445,4.445,0,0,0-.288,2.449V258a4.677,4.677,0,0,0,1.441,3.17,4.445,4.445,0,0,0,4.9.72,2.827,2.827,0,0,0,1.3-1.3l-1.153-1.009a2.3,2.3,0,0,1-2.017,1.153,2.167,2.167,0,0,1-1.585-.576,3.287,3.287,0,0,1-.864-1.729h5.619v-.865a6.93,6.93,0,0,0-1.153-3.314,4.284,4.284,0,0,0-2.882-1.153",
    transform: "translate(-302.876 -249.498)",
    fill: "#242424"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6432",
    "data-name": "Path 6432",
    d: "M323.267,253.1a3.078,3.078,0,0,0-2.449,1.153l-.144-1.009H318.8l.72,8.933h1.873l-.432-6.34a1.686,1.686,0,0,1,1.585-1.153,1.418,1.418,0,0,1,1.153.432,1.761,1.761,0,0,1,.432,1.3l.432,5.763h1.873L326,256.27c0-2.017-1.008-3.17-2.737-3.17",
    transform: "translate(-300.213 -249.498)",
    fill: "#242424"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6433",
    "data-name": "Path 6433",
    d: "M329.278,261.838a1.773,1.773,0,0,1-1.441-.72,4.251,4.251,0,0,1-.72-2.161,3.767,3.767,0,0,1,.288-2.305c.288-.576.72-.72,1.441-.72a2.1,2.1,0,0,1,1.873,1.009l.288,3.746a2.033,2.033,0,0,1-1.729,1.153m2.738-11.238h-1.873l.288,4.611a2.867,2.867,0,0,0-2.305-1.009,2.444,2.444,0,0,0-2.305,1.3,5.67,5.67,0,0,0-.72,3.314,7.536,7.536,0,0,0,1.153,3.458,3.273,3.273,0,0,0,2.593,1.3,2.37,2.37,0,0,0,2.161-1.153l.144.865h1.729l-.864-12.679",
    transform: "translate(-297.436 -250.6)",
    fill: "#242424"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6434",
    "data-name": "Path 6434",
    d: "M336.317,251.1H334.3l1.009,11.959h2.017L336.317,251.1",
    transform: "translate(-293.381 -250.38)",
    fill: "#242424"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6435",
    "data-name": "Path 6435",
    d: "M341.867,253.1a3.078,3.078,0,0,0-2.449,1.153l-.144-1.009H337.4l.72,8.933h1.873l-.432-6.34a1.686,1.686,0,0,1,1.585-1.153,1.418,1.418,0,0,1,1.153.432,1.761,1.761,0,0,1,.432,1.3l.432,5.763h1.873l-.432-5.907c0-2.017-1.009-3.17-2.737-3.17",
    transform: "translate(-292.014 -249.498)",
    fill: "#242424"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6436",
    "data-name": "Path 6436",
    d: "M350.836,253.2h-2.017l-1.3,6.484-2.305-6.484H343.2l3.6,8.933h1.729l2.305-8.933",
    transform: "translate(-289.457 -249.454)",
    fill: "#242424"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6437",
    "data-name": "Path 6437",
    d: "M351.361,254.214h-1.873l.72,8.933h1.873l-.72-8.933m-1.153-3.314a1.019,1.019,0,0,0-.72,1.729,1.218,1.218,0,0,0,.864.288,1.019,1.019,0,0,0,.72-1.729,2.048,2.048,0,0,0-.864-.288",
    transform: "translate(-286.812 -250.468)",
    fill: "#242424"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6438",
    "data-name": "Path 6438",
    d: "M354.77,251.7H352.9l.144,2.161H351.6l.144,1.441h1.441l.432,5.043c.144,1.729,1.009,2.593,2.449,2.593a3.988,3.988,0,0,0,1.3-.144l-.144-1.585c-.288,0-.432.144-.72.144a.985.985,0,0,1-1.009-1.009l-.432-4.9h1.585l-.144-1.441h-1.585l-.144-2.305",
    transform: "translate(-285.754 -250.115)",
    fill: "#242424"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6439",
    "data-name": "Path 6439",
    d: "M357.934,256.846a1.968,1.968,0,0,1,.576-1.585,1.747,1.747,0,0,1,2.593,0,2.3,2.3,0,0,1,.576,1.585v.144h-3.746m1.585-3.89a3.308,3.308,0,0,0-2.017.576,3.522,3.522,0,0,0-1.3,1.585,4.445,4.445,0,0,0-.288,2.449V258a4.677,4.677,0,0,0,1.441,3.17,4.445,4.445,0,0,0,4.9.72,2.828,2.828,0,0,0,1.3-1.3l-1.153-1.009a2.3,2.3,0,0,1-2.017,1.153,2.167,2.167,0,0,1-1.585-.576,3.287,3.287,0,0,1-.865-1.729h5.619v-.865a6.931,6.931,0,0,0-1.153-3.314,4.023,4.023,0,0,0-2.882-1.153",
    transform: "translate(-283.876 -249.498)",
    fill: "#242424"
  })))))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg3);
export default __webpack_public_path__ + "static/media/img3.2dacb6d9913e0ba6aaf3bd5727c712bf.svg";
export { ForwardRef as ReactComponent };